import React from 'react';
import { CCard, CCardBody, CCardGroup, CCol, CContainer, CRow } from '@coreui/react';
import Logo from '@/assets/images/ic_login_logo.svg';
import { useGlobalSettings } from '@/hooks';

/**
 * GuestLayout is a layout component designed for guest views, like login, registration, or password reset pages.
 * It centers the child content within the page and applies some basic styling for the background and spacing.
 * 
 * @param {object} props - The component props.
 * @param {React.ReactNode} children - The page content (e.g., form elements) to be displayed within the layout.
 * 
 * @returns {React.ReactNode} The rendered layout with centered content for guest users.
 */
const GuestLayout = ({ children }) => {
  const { settings: globalSettings } = useGlobalSettings();

  return (
    <div className="bg-body-tertiary d-flex flex-row login_box">
      <style jsx>{`
        .logo-change {
          background: transparent !important;
          background-color: transparent !important;
        }
      `}</style>
      {/* CContainer is used to create a responsive container */}
      <CContainer className='m-auto'>
        <CRow className="justify-content-center">
          {/* CCol is used to define a column that is centered and takes up 5 out of 12 grid columns on medium screens */}
          <CCol md={12} lg={8} className=''>
            {/* The children prop allows dynamic content (like forms or buttons) to be passed and rendered inside this layout */}
            <CCardGroup>
              <CCard className="py-md-5 border-0 rounded-0 m-0 login-box-logo" style={{ background: 'linear-gradient(135deg, #7C3AED 0%, #6D28D9 100%)' }}>
                <CCardBody className="text-center d-flex align-items-center justify-content-center">
                  <div className='text-center w-full p-3'>
                    <img
                      src={globalSettings?.home_page_general_login_page_logo || Logo}
                      alt="Login Logo"
                      height={170}
                      width={150}
                      className='object-fit-contain'
                      style={{
                        backgroundColor: 'transparent',
                        border: 'none',
                        outline: 'none',
                        boxShadow: 'none'
                      }}
                    />
                  </div>
                </CCardBody>
              </CCard>
              <CCard className="p-4 border-0 rounded-0 m-0">
                <CCardBody>
                  {children}
                </CCardBody>
              </CCard>
            </CCardGroup>

          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default GuestLayout;
